import React from 'react';
import { Shield, Users, Building, Target, Clock, TrendingUp } from 'lucide-react';

interface ServicesProps {
  isDarkMode?: boolean;
}

const Services: React.FC<ServicesProps> = ({ isDarkMode = false }) => {
  const services = [
    {
      icon: Shield,
      title: "Managed Security Services",
      description: "24/7 SOC monitoring, threat detection, and incident response with expert security analysts."
    },
    {
      icon: Users,
      title: "Security Consulting",
      description: "Strategic cybersecurity planning, risk assessments, and compliance guidance from certified experts."
    },
    {
      icon: Building,
      title: "Enterprise Solutions",
      description: "Scalable security infrastructure, SIEM implementation, and custom security architecture."
    },
    {
      icon: Target,
      title: "Penetration Testing",
      description: "Comprehensive security testing, vulnerability assessments, and remediation strategies."
    },
    {
      icon: Clock,
      title: "Incident Response",
      description: "Rapid response team, forensic analysis, and recovery planning for security incidents."
    },
    {
      icon: TrendingUp,
      title: "Security Training",
      description: "Employee awareness programs, phishing simulations, and security best practices training."
    }
  ];

  return (
    <section id="services" className={`py-20 ${isDarkMode ? 'bg-slate-950' : 'bg-slate-50'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${
            isDarkMode ? 'text-slate-100' : 'text-slate-900'
          }`}>
            Comprehensive Security Services
          </h2>
          <p className={`text-xl max-w-3xl mx-auto ${
            isDarkMode ? 'text-slate-300' : 'text-slate-600'
          }`}>
            From threat monitoring to compliance management, we provide end-to-end 
            cybersecurity solutions for enterprises across India and Australia.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className={`p-8 rounded-xl hover:shadow-lg transition-shadow ${
              isDarkMode ? 'bg-slate-900 hover:bg-slate-800' : 'bg-white hover:bg-slate-50'
            }`}>
              <service.icon className={`h-12 w-12 mb-4 ${
                isDarkMode ? 'text-blue-400' : 'text-blue-600'
              }`} />
              <h3 className={`text-xl font-semibold mb-3 ${
                isDarkMode ? 'text-slate-100' : 'text-slate-900'
              }`}>{service.title}</h3>
              <p className={isDarkMode ? 'text-slate-300' : 'text-slate-600'}>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;